export default __webpack_public_path__ + "images/f0a8e349e179b0a9a41562f7750a0866-tankBullet2.png";